import React from 'react';
import styles from './FooterShade.module.scss';

export const FooterShade = () => <div className={styles.root} />;
